import type { ReactNode } from 'react';
import { cn } from './cn';

const SIZES = {
  hero: 'text-hero',
  lg: 'text-display-lg',
  md: 'text-display-md',
} as const;

/**
 * A Fraunces title whose translation sets one word in italics (P15, backlog §21): `Your <em>boards</em>`. Only
 * `<em>…</em>` becomes markup; anything else in the string stays text, so a translation can never inject HTML.
 */
export function DisplayTitle({ text, as: Tag = 'h2', size = 'lg', className }: { text: string; as?: 'h1' | 'h2' | 'p'; size?: keyof typeof SIZES; className?: string }) {
  const parts: ReactNode[] = text.split(/<em>(.*?)<\/em>/).map((part, i) =>
    i % 2 ? (
      <em key={i} className="font-display font-normal italic">
        {part}
      </em>
    ) : (
      part
    ),
  );
  return <Tag className={cn('font-display font-normal tracking-display text-fg', SIZES[size], className)}>{parts}</Tag>;
}
